<template>
  <v-container fluid class="contenedor">
    <v-layout align-center justify-center>
      <v-flex sm12 md10 lg11>
        <div class="text-center">
          <img src="@/assets/images/logo_white.png" width="170" alt="Creditoria"/>
        </div>
        <v-card>
          <v-card-text>

            <v-row dense>
              <v-col cols="12" v-if="credito">
                <p class="text-sm-h5 text-md-h4 text-m=lg-h3 font-weight-bold text-uppercase text-title-color-verde">
                  {{ credito.nombres }} {{  credito.apellidos }}
                </p>
                <div class="subtitle-1 font-weight-bold text-uppercase text-title-color-verde">
                  Correo : <span class="text-title-color-dorado font-weight-light">{{ credito.email }}</span>
                </div>
                <div class="subtitle-1 font-weight-bold text-uppercase text-title-color-verde">
                  Telefono : <span class="text-title-color-dorado font-weight-light">{{ credito.phone }}</span>
                </div>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="6">
                <v-card class="mx-auto" elevation="0">
                  <v-card-text>
                    <p class="text-h5 text-sm-h5 text-md-h4 text-center text-contenedor"> DATOS DEL CRÉDITO </p>
                    <v-row dense >
                      <v-col cols="12">
                        <v-text-field
                          v-model="credito.precioVivienda"
                          prefix="$"
                          label="PRECIO VIVIENDA"
                          :rules="fieldRequired"
                          :readonly="isreadonly"
                          @keydown="validateCaracter"
                          outlined
                          dense
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="credito.creditoBanco"
                            label="CREDITO DEL BANCO"
                            type="number"
                            prefix="$"
                            min="0"
                            outlined
                            dense/>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="PorcentajeCreditoBanco"
                            label="PORCENTAJE CREDITO"
                            :rules="fieldRequired"
                            type="number"
                            suffix="%"
                            min="0"
                            readonly
                            outlined
                            dense
                          />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="mx-auto" elevation="0">
                  <v-card-text>
                  <p class="text-h5 text-sm-h5 text-md-h4 text-lg-h5 text-center text-contenedor"> GASTOS DEL CRÉDITO </p>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="CostosEscritura"
                          label="GASTO DE ESCRITURA"
                          :rules="fieldRequired"
                          type="number"
                          prefix="$"
                          min="0"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="CostoAvaluo"
                          label="COSTO DE AVALUO APROX."
                          :rules="fieldRequired"
                          type="number"
                          prefix="$"
                          min="0"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="ComisionBancaria"
                          label="COMISION APERTURA"
                          type="number"
                          prefix="$"
                          min="0"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="porcentaje"
                          label="PORCENTAJE COMISION"
                          suffix="%"
                          readonly
                          outlined
                          dense/>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="MontoEnganche"
                          label="MONTO DE ENGANCHE"
                          type="number"
                          prefix="$"
                          min="0"
                          readonly
                          outlined
                          dense/>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <p class="text-h6 text-center text-contenedor">
                          TOTAL DE ENGANCHE + GASTOS
                        </p>
                        <p class="text-h5 text-sm-h5 text-md-h5 text-center">
                          $ {{ this.intlRound(this.CostosEscritura + this.CostoAvaluo + this.ComisionBancaria + this.MontoEnganche) }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-toolbar dense dark color="#026270">
                  <v-toolbar-title>
                    <h3 class="text-center text-p">COMPARATIVO CRÉDITO BANCARIO 20 AÑOS</h3>
                  </v-toolbar-title>
                </v-toolbar>
                <v-progress-linear :active="loading" indeterminate color="#d68110"></v-progress-linear>
                <v-simple-table class="elevation-3">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="black--text">BANCO</th>
                        <th class="black--text">TASA</th>
                        <th class="black--text">INTERES</th>
                        <th class="black--text">CAPITAL</th>
                        <th class="black--text">SEGURO VIDA</th>
                        <th class="black--text">SEGURO DAÑOS</th>
                        <th class="black--text">COMISION</th>
                        <th class="black--text">MENSUALIDAD</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in generateTable" :key="index">
                        <td class="black--text">{{ item.banco.nombre }}</td>
                        <td>{{ item.banco.tasa_nombre }}</td>
                        <td>{{ intlRound(item.calculo.interes) }}</td>
                        <td>{{ intlRound(item.calculo.capital) }}</td>
                        <td>{{ intlRound(item.calculo.seguroVida) }}</td>
                        <td>{{ intlRound(item.calculo.seguroDanios) }}</td>
                        <td>{{ intlRound(item.banco.comision) }}</td>
                        <td class="black--text">{{ intlRound(item.calculo.mensualidad) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <p class="text-sm-h5 text-md-h5 text-center text-contenedor"> ¿Quieres saber que monto de crédito te puede prestar el Banco de acuerdo con tus
                  ingresos y buro de crédito?
                </p>
                <v-btn color="#026270" @click="sendBuro" tile large dark>
                  <div class="text-md-h4">
                    ¡PRECALIFICATE AHORA
                    <span class="text-lowercase"> con un click</span>!
                  </div>

                </v-btn>
              </v-col>

              <v-col cols="12" offset-sm="1" sm="10" md="6" offset-md="3" class="pt-5">
                <p class="body-2 text-title-color-verde text-justify">
                  * Son tasas promedio por cada institución, la tasa puede bajar y subir de acuerdo con el análisis
                    de riesgo por parte del banco, monto de enganche y plazo del crédito. Consulta con un asesor.
                    Información para fines informativos y de comparación exclusivamente *
                </p>
                <p class="body-2 text-title-color-dorado text-justify">
                  * Revisa tu email donde recibirás esta información en caso de no visualizarlo en tu bandeja de
                  entrada verificar SPAM
                </p>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
export default {
  mixins: [Validate, NumberUtils],
  data: () => ({
    clienteRegistrado: {},
    credito: {},
    porcentaje: 1,
    generateTable: [],
    isreadonly: false,
    loading: true,
    referencia: '',
    fullPath: ''
  }),
  mounted () {
    this.credito = this.$cookies.get('credito_gral')
    this.PostListObjects({ url: '/precalificacion-gral/deadlines', data: { plazo: '20 AÑOS', tipo: 'CREDITO BANCARIO' } })
    // seccion para guardar informacion
    // console.log('credito', this.credito)
    this.referencia = this.credito.referencia
    this.fullPath = this.credito.fullPath
    this.PostObject({ url: 'precalificador/store', data: this.credito })
  },
  methods: {
    ...mapActions(['PostObject', 'PostObjectSeccound', 'PostListObjects', 'PostObjectThird']),
    ...mapMutations(['SET_PROGRESS_EMAIL']),
    sendBuro () {
      window.open('http://t.nocnok.com/s/j_asuarez?refh=web', '_blank')
    },
    tabla (plazo) {
      if (this.credito.creditoBanco > 0 && this.credito.precioVivienda > 0) {
        const interes = ((this.credito.creditoBanco * (plazo.banco.tasa / 100)) * plazo.banco.dias_mes) / plazo.banco.dias_anio
        const capital = this.credito.creditoBanco * plazo.capital
        const seguroVida = this.credito.creditoBanco * plazo.seguroVida
        const seguroDanios = this.credito.precioVivienda * plazo.banco.seguroddanios
        const comision = parseFloat(plazo.banco.comision)
        const mensualidad = interes + capital + seguroVida + seguroDanios + comision
        return {
          interes: interes,
          capital: capital,
          seguroVida: seguroVida,
          seguroDanios: seguroDanios,
          mensualidad: mensualidad
        }
      }
      return {
        interes: 0,
        capital: 0,
        seguroVida: 0,
        seguroDanios: 0,
        mensualidad: 0
      }
    },
    validateCaracter (e) {
      // Si el código es menor que 48 (0) o mayor que 57 (9)
      if (e.keyCode < 48 || e.keyCode > 57) {
        if (e.keyCode !== 8) {
          // No se agrega
          e.preventDefault()
        }
        // No se agrega
        // e.preventDefault()
      }
    }
  },
  computed: {
    ...mapGetters(['get_porcentajeAvaluo', 'get_object', 'get_objects', 'get_objectSeccound']),
    PorcentajeCreditoBanco () {
      const valorVivienda = (this.credito.precioVivienda) ? parseFloat(this.credito.precioVivienda) : 0
      const creditoBanco = (this.credito.creditoBanco) ? parseFloat(this.credito.creditoBanco) : 0
      if (valorVivienda > 0) {
        return ((creditoBanco / valorVivienda) * 100)
      }
      return 0
    },
    CostosEscritura () {
      const valorVivienda = (this.credito.precioVivienda) ? parseFloat(this.credito.precioVivienda) : 0
      if (valorVivienda > 0) {
        const escrita = valorVivienda * (6 / 100)
        return escrita
      }
      return 0
    },
    CostoAvaluo () {
      const valorVivienda = (this.credito.precioVivienda) ? parseFloat(this.credito.precioVivienda) : 0
      if (valorVivienda > 0) {
        const avaluo = valorVivienda * 0.0035
        return avaluo
      }
      return 0
    },
    ComisionBancaria () {
      const creditoBanco = (this.credito.creditoBanco) ? parseFloat(this.credito.creditoBanco) : 0
      if (creditoBanco > 0) {
        const comBanc = creditoBanco * (this.porcentaje / 100)
        return comBanc
      }
      return 0
    },
    MontoEnganche () {
      const creditoBanco = (this.credito.creditoBanco) ? parseFloat(this.credito.creditoBanco) : 0
      const precioVivienda = (this.credito.precioVivienda) ? parseFloat(this.credito.precioVivienda) : 0
      if (creditoBanco > 0 && precioVivienda > 0) {
        const enganche = precioVivienda - creditoBanco
        return enganche
      }
      return 0
    }
  },
  watch: {
    get_objects (vals) {
      this.loading = false
      if (vals) {
        this.generateTable = []
        const bancos = vals
        bancos.map(plazo => {
          plazo.calculo = this.tabla(plazo)
        })
        this.generateTable = bancos
      }
    },
    get_object (val) {
      this.clienteRegistrado = val
      this.credito.cliente_id = val.id
      this.credito.tipoCredito = 'bancario'
      this.credito.plazo = '20 AÑOS'
      this.credito.porcentajeComisionBanco = 1
      this.credito.porcentajeCredito = this.PorcentajeCreditoBanco
      this.PostObjectSeccound({ url: 'precalificador/credito/tipo-credito', data: this.credito })
      // this.PostObjectThird({ url: 'precalificador/credito/sendEmail', data: this.credito })
    },
    get_objectSeccound (val) {
      console.log(val)
      if (val.message) {
        console.log('message', val.message)
        return
      }
      this.credito.tipo_credito_id = val.id
      this.credito.referencia = this.referencia
      this.PostObjectThird({ url: 'precalificador/credito/sendEmail', data: this.credito })
    }
  }
}
</script>

<style scoped>
.contenedor {
  background-color: #026270;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  max-width: 100%;
  min-height: 100%;
}
.text-contenedor{
  background-color: #026270;
  color: white;
  font-family: inherit !important;
  padding: 6px;
}
.text-title-color-dorado{
  color: #d68110;
  font-family: inherit !important;
}
.text-title-color-verde{
  color: #026270;
  font-family: inherit !important;
}

</style>
